module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAwCAYAAAB5R9gVAAAABGdBTUEAALGPC/xhBQAAAH1JREFUWAnt0rEJwDAQBEHxjVtdCUfu7BGqYBUcjtbpwlsMN0boW+/3JE5V4si50d0zcSv2oMRjzg0fRJIKKUQC1N2QQiRA3Q0pRALU3ZBCJEDdDSlEAtTdkEIkQN0NKUQC1N2QQiRA3Q0pRALU3ZBCJEDdDf0mVFWTfnbTN+TSBw1ggAYXAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_line.png
// module id = uOIv
// module chunks = 1